export default __webpack_public_path__ + "madfit-screen-seventh.39585dcc.png";